import { render, staticRenderFns } from "./demandInfo.vue?vue&type=template&id=77acf54a&scoped=true&"
import script from "./demandInfo.vue?vue&type=script&lang=js&"
export * from "./demandInfo.vue?vue&type=script&lang=js&"
import style0 from "./demandInfo.vue?vue&type=style&index=0&id=77acf54a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77acf54a",
  null
  
)

export default component.exports